import React from "react";
//#region types
import { PrintMonthlyResultReportProps } from "models/propTypes/accountingPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModelFinancialReport } from "wint-api-client/dist/types";
//#endregion
//#region components
import { NestedTablePrint } from "components/common";
import useFinancialReportRow from "../.././hooks/useFinancialReportRow";
//#endregion
import { FinancialReportHelper, LocalizationHelperInstance } from "utils/helpers";

const PrintMonthlyResultReport: React.FC<PrintMonthlyResultReportProps> = (props) => {
  const { title, subtitle, result, amountFormatter, amountHeaderDescription, showAccountNumber } = props;

  const { descriptionFormatter } = useFinancialReportRow(showAccountNumber);

  return (
    <NestedTablePrint<
      WintSuperkollAPIModelFinancialReport.FinancialReportRow,
      WintSuperkollAPIModelFinancialReport.FinancialReportRowColumn
    >
      title={title}
      subTitle={subtitle}
      rows={result}
      properties={{
        description: {
          description: TranslationKeys.Common.Name,
          formatter: descriptionFormatter,
        },
      }}
      repeatProperties={{
        key: "columns",
        properties: {
          amount: {
            description: amountHeaderDescription,
            formatter: (row: WintSuperkollAPIModelFinancialReport.FinancialReportRowColumn) =>
              LocalizationHelperInstance.getFormattedCurrency(amountFormatter(row) ?? 0, undefined, 0, 0),
            alignment: "right",
          },
        },
        showTotal: {
          key: "amount",
          valueFormatter: amountFormatter,
          displayFormatter: (value: number) => LocalizationHelperInstance.getFormattedCurrency(value, undefined, 0, 0),
        },
        sumNegative: (row: WintSuperkollAPIModelFinancialReport.FinancialReportRowColumn) => row.amount > 0,
      }}
      childrenKey="children"
      rowDisplayType={FinancialReportHelper.getResultReportRowDisplayType}
      maxRepeatColumns={13}
      repeatColumnDefaultWidth={45}
    />
  );
};

export default PrintMonthlyResultReport;
